import { Box, Typography } from '@mui/material';
import { Button, Modal, ModalProps } from 'components/ui';
import React, { ReactElement, useEffect, useState } from 'react';
import { useProfileApi } from 'services/api';
import { useSnackbar } from 'notistack';
import { throttle } from 'lodash';
import { mutateProfile } from 'hooks';

export interface RemoveEmailModalProps
  extends Pick<ModalProps, 'open' | 'onClose'> {
  email: string;
}

export const RemoveEmailModal = ({
  open,
  onClose,
  email,
}: RemoveEmailModalProps): ReactElement => {
  const [isSubmitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!open) setSubmitting(false);
  }, [open]);

  const profileApi = useProfileApi();

  const { enqueueSnackbar } = useSnackbar();

  const onSubmit = throttle(
    async (e: React.FormEvent) => {
      e.preventDefault();
      setSubmitting(true);
      const result = await profileApi.removeEmail(email);

      if (result.success) {
        await mutateProfile();
        return onClose?.();
      }

      setSubmitting(false);
      enqueueSnackbar(result.error.message, { variant: 'error' });
    },
    200,
    { leading: true },
  );

  return (
    <Modal title="Remove Email" open={open} onClose={onClose}>
      <form onSubmit={onSubmit}>
        <Typography>Are you sure you want to remove your email:</Typography>
        <Typography fontWeight="900">{email}</Typography>

        <Box mt={20} width="min(70vw, 685px)" display="flex">
          <Box mr={30}>
            <Button minWidth={100} inverted onClick={onClose}>
              Cancel
            </Button>
          </Box>
          <Button
            type="submit"
            minWidth={100}
            variant="vibrant"
            disabled={isSubmitting}
          >
            Remove Email
          </Button>
        </Box>
      </form>
    </Modal>
  );
};
